import { useState } from 'react';

import type { ClientId, SessionChargeId } from '@nesso/ledger-contracts/ids';
import { Sheet, SheetContent } from '@nesso/ui/primitives/sheet';

import { useSheetStore } from '@/shared/stores/sheet-store';

import { RecordPaymentSheetContent } from './record-payment-sheet/record-payment-sheet-content';

type Props = {
    clientId: ClientId;
    clientName: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    selectedSessionChargeId: SessionChargeId | null;
};

export function RecordPaymentSheet({
    clientId,
    clientName,
    open,
    onOpenChange,
    selectedSessionChargeId,
}: Props) {
    const closeAllSheets = useSheetStore((state) => state.closeAllSheets);
    const [pending, setPending] = useState(false);

    function handleOpenChange(next: boolean) {
        if (pending) return;
        if (!next) closeAllSheets();
        onOpenChange(next);
    }

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent side="right" size="medium" variant="chart" showCloseButton={false}>
                <RecordPaymentSheetContent
                    clientId={clientId}
                    clientName={clientName}
                    selectedSessionChargeId={selectedSessionChargeId}
                    onClose={() => onOpenChange(false)}
                    onBreadcrumbNavigate={(navigate) => {
                        if (pending) return;
                        navigate();
                        onOpenChange(false);
                    }}
                    onPendingChange={setPending}
                />
            </SheetContent>
        </Sheet>
    );
}
